import { ExclamationTriangleIcon, XMarkIcon } from '@heroicons/react/24/outline';
import { useAuthStore } from '../../stores/authStore';
import { useSocketStore } from '../../stores/socketStore';

const ADMIN_ROLES = ['org_admin', 'super_admin'];

export default function MailQuotaBanner() {
  const { user } = useAuthStore();
  const { mailQuotaWarnings, dismissMailQuotaWarning } = useSocketStore();

  if (!ADMIN_ROLES.includes(user?.role) || mailQuotaWarnings.length === 0) return null;

  return (
    <div
      className="fixed top-0 left-0 right-0 z-[9998] bg-amber-500 text-white"
      role="alert"
      aria-live="polite"
    >
      {mailQuotaWarnings.map((warning) => (
        <div
          key={warning.siteId}
          className="flex items-center justify-center gap-2 px-4 py-2 text-sm font-medium border-t border-amber-400/50 first:border-t-0"
        >
          <ExclamationTriangleIcon className="w-4 h-4 flex-shrink-0" aria-hidden="true" />
          <span>
            {warning.siteName}: mail alerts at {warning.percentage}% of daily cap ({warning.count}/{warning.cap})
          </span>
          <button
            onClick={() => dismissMailQuotaWarning(warning.siteId)}
            className="ml-2 flex-shrink-0 hover:text-amber-100"
            aria-label="Dismiss"
          >
            <XMarkIcon className="w-4 h-4" />
          </button>
        </div>
      ))}
    </div>
  );
}
